import * as Yup from "yup";

export const validation = () => (
    Yup.object({
        username: Yup.string()
            .required('Prihlasovacie meno je povinné.')
            .min(3, 'Minimálny počet znakov je 3.')
            .max(15, 'Maximálny počet znakov je 15.'),
        email: Yup.string()
            .required('E-mail je povinný.')
            .email('Nesprávny formát e-mailu.')
            .min(5, 'Minimálny počet znakov je 5.')
            .max(40, 'Maximálny počet znakov je 40.'),
        contact: Yup.string()
            .required('Mobil je povinný.')
            .matches(/\+421[0-9]{9}/, 'Telefónne číslo nie je vo formáte slovenského čísla.')
            .min(13, 'Minimálny počet znakov je 13.')
            .max(13, 'Maximálny počet znakov je 13.'),
        name: Yup.string()
            .required('Meno je povinné.')
            .min(2, 'Minimálny počet znakov je 2.')
            .max(50, 'Maximálny počet znakov je 50.'),
        surname: Yup.string()
            .required('Priezvisko je povinné')
            .min(2, 'Minimálny počet znakov je 2.')
            .max(50, 'Maximálny počet znakov je 50.'),
        password: Yup.string()
            .required('Heslo je povinné.')
            .min(8, 'Minimálny počet znakov je 8.')
            .max(20, 'Maximálny počet znakov je 20.')
            .matches(/^(?=.*[A-Z]).{8,20}$/, 'Heslo musí obsahovať aspoň jedno veľké písmeno.'),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('password'), null], 'Heslá sa nezhodujú.')
            .required('Potvrdenie hesla je povinné.')
            .min(8, 'Minimálny počet znakov je 8.')
            .max(20, 'Maximálny počet znakov je 20.')
            .matches(/^(?=.*[A-Z]).{8,20}$/, 'Heslo musí obsahovať aspoň jedno veľké písmeno.'),
    })
)
